import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  background: #2c5aa0;
  color: #fff;
  padding: 40px 0 20px;
  margin-top: auto;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

const FooterSection = styled.div`
  h3 {
    font-size: 18px;
    margin-bottom: 15px;
    color: #fff;
  }

  p {
    margin-bottom: 10px;
    line-height: 1.6;
  }
`;

const FooterLogo = styled.img`
  height: 55px;
  width: auto;
  margin-bottom: 15px;
  object-fit: contain;
  filter: brightness(1.3) contrast(1.2); // 어두운 배경에서 잘 보이도록 밝게 조정
`;

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;

  svg {
    color: #ffd700;
    flex-shrink: 0;
  }
`;

const Copyright = styled.div`
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterSection>
          <FooterLogo
            src="/logo.png"
            alt="IJBC 얼바인중앙침례교회 로고"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
          <h3>Irvine Joongang Baptist Church</h3>
          <p>얼바인 중앙침례교회에 오신 것을 환영합니다.</p>
          <p>우리는 하나님의 말씀을 통해 지역사회에 복을 전하는 교회입니다.</p>
        </FooterSection>

        <FooterSection>
          <h3>예배 시간</h3>
          <ContactInfo>
            <span style={{ fontSize: '16px', color: '#ffd700' }}>🕐</span>
            <span>주일예배: 오전 11:00</span>
          </ContactInfo>
          <ContactInfo>
            <span style={{ fontSize: '16px', color: '#ffd700' }}>🕐</span>
            <span>주중새벽기도: 화요일 새벽 6:00</span>
          </ContactInfo>
        </FooterSection>



        <FooterSection>
          <h3>연락처</h3>
          <ContactInfo>
            <span style={{ fontSize: '16px', color: '#ffd700' }}>📍</span>
            <span>240 Goddard, Irvine, CA 92618 U.S.A</span>
          </ContactInfo>
          <ContactInfo>
            <span style={{ fontSize: '16px', color: '#ffd700' }}>✉️</span>
            <span>ijbcorg@gmail.com</span>
          </ContactInfo>
        </FooterSection>
      </FooterContent>

      <Copyright>
        <p>Copyright ⓒ 2025 얼바인 중앙침례교회 All rights reserved. Developed by <a href="https://aicodeforge.ai" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline' }}>aicodeforge</a></p>
      </Copyright>
    </FooterContainer>
  );
};

export default Footer; 